import { render, staticRenderFns } from "./order-inquiry.vue?vue&type=template&id=742c7b6e&scoped=true&"
import script from "./order-inquiry.vue?vue&type=script&lang=js&"
export * from "./order-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./order-inquiry.vue?vue&type=style&index=0&id=742c7b6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c7b6e",
  null
  
)

export default component.exports